import React from "react";
import { Table } from "react-bootstrap";

const NOCCheckList = ({checklist}) => {
  const url = window.location.href;
  const isStructuralOrEmployee = url.includes("structural") || url.includes("employee");
  return (
    <section className="container1">
      <form>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Checklist</h2>
          </div>
          <div className="formInputContainer">
            <Table striped bordered className="m-0" style={{width: isStructuralOrEmployee ? '82%' : '100%'}}>
              <thead>
                <tr>
                  <th style={{ minWidth: 'fit-content' }}>Sr.<br />No.</th>
                  <th style={{ minWidth: 'fit-content' }}>Description</th>
                  <th style={{ minWidth: 'fit-content' }}>Detail of Regulation as per provision</th>
                  <th style={{ minWidth: 'fit-content' }}>Detail of Regualtion as per approved plan</th>
                  <th style={{ minWidth: 'fit-content' }}>Provision made as per approved plan</th>
                  <th style={{ minWidth: 'fit-content' }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Built up Area</td>
                  <td>{checklist?.buildupAreaNOC?.regulated}</td>
                  <td>{checklist?.buildupAreaNOC?.proposed || checklist?.builtupArea}</td>
                  <td>{checklist?.buildupAreaNOC?.relaxation}</td>
                  <td>{checklist?.buildupAreaNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>FAR</td>
                  <td>{checklist?.farNOC?.regulated}</td>
                  <td>{checklist?.farNOC?.proposed}</td>
                  <td>{checklist?.farNOC?.relaxation}</td>
                  <td>{checklist?.farNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>% Coverage</td>
                  <td>{checklist?.coverageNOC?.regulated}</td>
                  <td>{checklist?.coverageNOC?.proposed}</td>
                  <td>{checklist?.coverageNOC?.relaxation}</td>
                  <td>{checklist?.coverageNOC?.remarks}</td>
                </tr>
                <tr>
                  <td rowSpan={5} style={{ verticalAlign: 'top' }}>4</td>
                  <td>
                    Setbacks(meter)
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Front</td>
                  <td>{checklist?.regulatedsetBacks?.front}</td>
                  <td>{checklist?.setBacks?.front}</td>
                  <td>{checklist?.setBacks_relaxation_NOC?.front}</td>
                  <td>{checklist?.setBacks_remarks}</td>
                </tr>
                <tr>
                  <td>Rear</td>
                  <td>{checklist?.regulatedsetBacks?.rear}</td>
                  <td>{checklist?.setBacks?.rear}</td>
                  <td>{checklist?.setBacks_relaxation_NOC?.rear}</td>
                  <td>{checklist?.setBacks_remarks}</td>
                </tr>
                <tr>
                  <td>Left Side</td>
                  <td>{checklist?.regulatedsetBacks?.left}</td>
                  <td>{checklist?.setBacks?.left}</td>
                  <td>{checklist?.setBacks_relaxation_NOC?.left}</td>
                  <td>{checklist?.setBacks_remarks}</td>
                </tr>
                <tr>
                  <td>Right Side</td>
                  <td>{checklist?.regulatedsetBacks?.right}</td>
                  <td>{checklist?.setBacks?.right}</td>
                  <td>{checklist?.setBacks_relaxation_NOC?.right}</td>
                  <td>{checklist?.setBacks_remarks}</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>No of Storeys</td>
                  <td>{checklist?.numberOfStoreysNOC?.regulated}</td>
                  <td>{checklist?.numberOfStoreysNOC?.proposed}</td>
                  <td>{checklist?.numberOfStoreysNOC?.relaxation}</td>
                  <td>{checklist?.numberOfStoreysNOC?.remarks}</td>
                </tr>
              
                <tr>
                  <td>6</td>
                  <td>Roads/Path exist at a site (Whether path develop at the site or not)</td>
                  <td>{checklist?.pathDevelopNOC?.regulated}</td>
                  <td>{checklist?.pathDevelopNOC?.proposed}</td>
                  <td>{checklist?.pathDevelopNOC?.relaxation}</td>
                  <td>{checklist?.pathDevelopNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Parking Provision</td>
                  <td>{checklist?.parkingProvisionNOC?.regulated}</td>
                  <td>{checklist?.parkingProvisionNOC?.proposed || checklist?.parkingProvision}</td>
                  <td>{checklist?.parkingProvisionNOC?.relaxation}</td>
                  <td>{checklist?.parkingProvisionNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Whether any HT/LT line crossing over the proposed land</td>
                  <td>{checklist?.htLineNOC?.regulated}</td>
                  <td>{checklist?.htLineNOC?.proposed || checklist?.whetherHtLtLineCrossing}</td>
                  <td>{checklist?.htLineNOC?.relaxation}</td>
                  <td>{checklist?.htLineNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Provision for solar passive building technology made or not</td>
                  <td>{checklist?.provisionOfSolarNOC?.regulated}</td>
                  <td>{checklist?.provisionOfSolarNOC?.proposed}</td>
                  <td>{checklist?.provisionOfSolarNOC?.relaxation}</td>
                  <td>{checklist?.provisionOfSolarNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Provision of barrier-free access for person</td>
                  <td>{checklist?.barrierfreeNOC?.regulated}</td>
                  <td>{checklist?.barrierfreeNOC?.proposed}</td>
                  <td>{checklist?.barrierfreeNOC?.relaxation}</td>
                  <td>{checklist?.barrierfreeNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>Provision of rainwater harvesting tank (optional in case of the building having a roof area less than 200 Sqm) Connectivity to the rainwater harvesting tank.</td>
                  <td>{checklist?.provisionRainWaterHarvestingNOC?.regulated}</td>
                  <td>{checklist?.provisionRainWaterHarvestingNOC?.proposed}</td>
                  <td>{checklist?.provisionRainWaterHarvestingNOC?.relaxation}</td>
                  <td>{checklist?.provisionRainWaterHarvestingNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Number of Dwelling Units</td>
                  <td>{checklist?.numberOfDwellingUnitsNOC?.regulated}</td>
                  <td>{checklist?.numberOfDwellingUnitsNOC?.proposed}</td>
                  <td>{checklist?.numberOfDwellingUnitsNOC?.relaxation}</td>
                  <td>{checklist?.numberOfDwellingUnitsNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>Maximum Hill Cut</td>
                  <td>{checklist?.maxHillCutNOC?.regulated}</td>
                  <td>{checklist?.maxHillCutNOC?.proposed}</td>
                  <td>{checklist?.maxHillCutNOC?.relaxation}</td>
                  <td>{checklist?.maxHillCutNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>Whether sewer exists in the vicinity or not. Connectivity to the sewer line.</td>
                  <td>{checklist?.sewerNOC?.regulated}</td>
                  <td>{checklist?.sewerNOC?.proposed}</td>
                  <td>{checklist?.sewerNOC?.relaxation}</td>
                  <td>{checklist?.sewerNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>Provision of Septic tank</td>
                  <td>{checklist?.septicNOC?.regulated}</td>
                  <td>{checklist?.septicNOC?.proposed}</td>
                  <td>{checklist?.septicNOC?.relaxation}</td>
                  <td>{checklist?.septicNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>Provision of a sloping roof</td>
                  <td>{checklist?.heightOfSloppingRoofNOC?.regulated}</td>
                  <td>{checklist?.heightOfSloppingRoofNOC?.proposed || checklist?.heightOfSloppingRoof}</td>
                  <td>{checklist?.heightOfSloppingRoofNOC?.relaxation}</td>
                  <td>{checklist?.heightOfSloppingRoofNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>17</td>
                  <td>Height raising/Plinth level</td>
                  <td>{checklist?.plinthHeightNOC?.regulated}</td>
                  <td>{checklist?.plinthHeightNOC?.proposed}</td>
                  <td>{checklist?.plinthHeightNOC?.relaxation}</td>
                  <td>{checklist?.plinthHeightNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>The closed floor in any</td>
                  <td>{checklist?.closedFloorNOC?.regulated}</td>
                  <td>{checklist?.closedFloorNOC?.proposed}</td>
                  <td>{checklist?.closedFloorNOC?.relaxation}</td>
                  <td>{checklist?.closedFloorNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>Retaining work and site development</td>
                  <td>{checklist?.retainingworkNOC?.regulated}</td>
                  <td>{checklist?.retainingworkNOC?.proposed}</td>
                  <td>{checklist?.retainingworkNOC?.relaxation}</td>
                  <td>{checklist?.retainingworkNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>
                  Boundary Wall erected or not
                  </td>
                  <td>{checklist?.boundaryWallsNOC?.regulated}</td>
                  <td>{checklist?.boundaryWallsNOC?.proposed}</td>
                  <td>{checklist?.boundaryWallsNOC?.relaxation}</td>
                  <td>{checklist?.boundaryWallsNOC?.remarks}</td>
                </tr>
                <tr>
                  <td>21</td>
                  <td>
                  Whether the building is above the road on the valley side.                  
                  </td>
                  <td>{checklist?.aboveValleySideNOC?.regulated}</td>
                  <td>{checklist?.aboveValleySideNOC?.proposed}</td>
                  <td>{checklist?.aboveValleySideNOC?.relaxation}</td>
                  <td>{checklist?.aboveValleySideNOC?.remarks}</td>                
                  </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </form>
    </section>
  );
};

export default NOCCheckList;
